import { useMemo } from 'react';

import CustomSelect from 'components/custom-select';
import { useAuth } from 'context/AuthContext';
import { GetVersion } from 'services/utils';

interface CycleSelectorProps {
  /** Nome acessível. No menu, que divide a tela com o seletor da própria tela, diz que é o do menu. */
  rotulo?: string;
}

export default function CycleSelector({ rotulo = 'Selecione o ciclo' }: CycleSelectorProps) {
  const { realCycle, cycleSelected, setCycleSelected, loadingInfo } = useAuth();

  const cycles = useMemo(
    () =>
      realCycle?.map((cycle: any) => ({
        _id: cycle._id,
        title: cycle.title,
        version: GetVersion(cycle.date_start),
      })),
    [realCycle],
  );

  if (!Array.isArray(cycles) || !cycles.length) return null;

  return (
    <CustomSelect
      variant="sidebar"
      disabled={loadingInfo}
      value={{ label: cycleSelected?.title, value: cycleSelected?._id }}
      placeholder="Clique para selecionar o ciclo"
      ariaLabel={rotulo}
      options={cycles.map(cycle => ({ label: cycle.title, value: cycle._id }))}
      onChange={(option: any) => {
        const selected = cycles.find(cycle => cycle._id === option.value);
        // CIC-02 e CAN-01: troca o ciclo do app e o funci fica na tela, que acompanha o ciclo; ciclos antigos também
        // abrem na nova identidade (antes, a página inicial levava a `/v2/` ou `/v3/`).
        setCycleSelected(selected);
      }}
    />
  );
}
